import { shellFooterClassName } from '@/components/step-flow/StepFlowShell.styles';
import type { StepFlowFooterProps } from '@/components/step-flow/StepFlowShell.types';
import { Box, Button, Icon } from '@careflux/primitives';

export const StepFlowFooter = ({
  onBack,
  backLabel,
  onNext,
  nextLabel,
  nextDisabled = false,
  nextLoading = false,
}: StepFlowFooterProps) => (
  <Box
    as="footer"
    display="flex"
    align="center"
    justify={onBack ? 'between' : 'end'}
    paddingTop="lg"
    className={shellFooterClassName}
  >
    {onBack && (
      <Button variant="ghost" size="lg" onClick={onBack}>
        <Icon name="ArrowLeft" />
        {backLabel}
      </Button>
    )}
    <Button size="lg" onClick={onNext} disabled={nextDisabled} loading={nextLoading} aria-busy={nextLoading}>
      {nextLabel}
      {!nextLoading && <Icon name="ArrowRight" />}
    </Button>
  </Box>
);
